import { render } from "./achievement-count.vue?vue&type=template&id=50b0ae5b&scoped=true"
import script from "./achievement-count.vue?vue&type=script&lang=js"
export * from "./achievement-count.vue?vue&type=script&lang=js"

import "./achievement-count.vue?vue&type=style&index=0&id=50b0ae5b&scoped=scoped&lang=less"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50b0ae5b"]])

export default __exports__